import { observer } from 'mobx-react';
import i_ from 'i18next';
import React from 'react';
import Chip from '@material-ui/core/Chip';

import Table from '../commons/Table';

import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';

import Edit from './Edit';

const store = Stores.load('candidato');

class Usuario extends React.Component {
  componentWillMount() {
    UIStore.init(i_.t('candidato.title'), store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      i_.t('dialogs.remove-message', { count }),
      i_.t('dialogs.remove-title', { entity: 'candidato' })
    ).then(b => {
      if (b) {
        store.delete().then(() => store.query());
      }
    });
  };

  render() {
    return (
      <div>
        <Table
          columns={[
            { label: i_.t('candidato.nome'), field: 'nome' },
            { label: i_.t('candidato.cargo'), field: 'cargo.nome' },
            { label: i_.t('candidato.numero'), field: 'numero' },
            {
              label: i_.t('candidato.partido'),
              field: 'partido',
              func: partido => (
                <Chip
                  key={partido.id}
                  label={partido.sigla}
                  style={{
                    backgroundColor: partido.cor,
                    fontWeight: 'bold',
                    color: 'white',
                  }}
                />
              ),
            },
            { label: i_.t('candidato.registro'), field: 'registro' },
          ]}
          store={store}
          data={store.list}
          selected={store.selected}
          onAdd={() =>
            store.new({
              nome: '',
              cargo: '',
              numero: '',
              partido: '',
              registro: '',
            })
          }
          onEdit={() => store.open()}
          onDelete={() => this.handleDelete()}
        />
        <Edit />
      </div>
    );
  }
}

export default observer(Usuario);



// WEBPACK FOOTER //
// ./src/components/candidato/index.js